import styled from 'styled-components/macro'
import { em, rgba } from '../../utils/styles'

const HeaderButton = styled.button`
  margin: 0;
  border: 0;
  padding: ${em(8.5)} ${em(13)};
  background-color: transparent;
  text-decoration: none;
  cursor: pointer;

  &:focus {
    background-color: ${rgba('base', 0.1)};
  }
`

export default HeaderButton
